import { render } from "./ViolationCountFilteredWidget.vue?vue&type=template&id=c1874192&scoped=true"
import script from "./ViolationCountFilteredWidget.vue?vue&type=script&lang=js"
export * from "./ViolationCountFilteredWidget.vue?vue&type=script&lang=js"

import "./ViolationCountFilteredWidget.vue?vue&type=style&index=0&id=c1874192&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1874192"]])

export default __exports__